import React from 'react';
import { styled } from '@linaria/react';

import RadioButton from '@/components/RadioButton';

import ControlWrapper from './ControlWrapper';

export interface Props {
  id: string;
  label: string;
  value: string;
  setValue: (value: string) => void;
  options?: Array<string | { label: string; value: string }>;
  inline?: boolean;
  gridArea?: string;
  wrapperStyle?: React.CSSProperties;
  onChange?: (value: string) => void;
}

function RadioControl({
  id,
  label,
  value,
  setValue,
  options = [],
  inline,
  gridArea,
  wrapperStyle,
  onChange,
}: Props) {
  const formattedOptions = options.map((opt) => {
    if (typeof opt === 'object') {
      return opt;
    }

    return {
      label: opt,
      value: opt,
    };
  });

  return (
    <ControlWrapper
      id={id}
      label={label}
      labelAs="span"
      gridArea={gridArea}
      inline={inline}
      style={wrapperStyle}
    >
      <Options>
        {formattedOptions.map((option) => (
          <RadioButton
            key={option.value}
            name={`radio-group-${id}`}
            size={18}
            checked={value === option.value}
            onChange={() => {
              setValue(option.value);

              if (typeof onChange === 'function') {
                onChange(option.value);
              }
            }}
            // We want 32px of gap between options. 16px will come from the `gap` property, and 16px from padding. I'm doing this so that clicking kinda near the option will still select it.
            wrapperStyle={{ paddingRight: 16 }}
          >
            {option.label}
          </RadioButton>
        ))}
      </Options>
    </ControlWrapper>
  );
}

const Options = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: fit-content;
  gap: 16px;
  font-size: 0.875rem;
  white-space: nowrap;

  &:has(:focus-visible) {
    outline: 2px auto var(--color-text);
    outline-offset: 6px;
  }
`;

export default RadioControl;
